import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const PaymentInput = () => {
  const { paymentId = '', invoiceId } = useParams();
  const decodedId = paymentId ? atob(paymentId) : paymentId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [customer, setCustomers] = useState([]); 
  const [invoice, setInvoices] = useState([]);


  const route = 'payment';

  useEffect(() => {
    if (paymentId) {
      setIsEditing(true);
      
      fetchPaymentDetails();
    }


    fetchInvoiceDetails();
  }, [paymentId]);

  const fetchPaymentDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.payment}${id}/`, { headers });
      const paymentDetails = response.data;
      setFormData(paymentDetails);
    } catch (error) {
      console.error('Error fetching payment details:', error);
    }
  };

  const fetchInvoiceDetails = async () => {
        try {
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${invoiceId}/`, { headers });
            const invoiceDetails = response.data;
            setInvoices(invoiceDetails);
            fetchCustomer(invoiceDetails.customer)
            //console.log(invoiceDetails);
        } catch (error) {
            console.error('Error fetching invoice details:', error);
        }
    };

    const fetchCustomer = async (customerId) => {
    try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}${customerId}/`, { headers });
        const customerData = response.data;

        //console.log(customerData);    
 

        setCustomers(customerData);

    } catch (error) {
        console.error('Error fetching customer:', error);
    }
    };

  const paymentFields = [

    {
      name: 'invoice',
      type: 'hidden',
      value: invoiceId,
    },
    {
      name: 'invoice_number',
      label: 'Invoice Number',
      type: 'text',
      readOnly:true,
      value: invoice.invoice_number,
    },
    {
        name: 'customer_name',
        label: 'Customer',
        type: 'text',
        value: customer.name,
        readOnly: true,
    },
    {
        name: 'customer',
        label: 'Customer',
        type: 'hidden',
        value: customer.id,
        readOnly: true,
    },
    {
      name: 'amount_paid',
      label: 'Amount Paid',
      type: 'number',
      step: '0.01',
    },
    {
      name: 'payment_date',
      label: 'Payment Date',
      type: 'date',
    },
    {
    name: 'payment_method',
    label: 'Payment Method',
    type: 'select',
    options: [
        { value: 'Bank Transfer', label: 'Bank Transfer' },
        { value: 'Credit Card', label: 'Credit Card' },
        { value: 'Cash', label: 'Cash' },
        { value: 'Mobile Payment', label: 'Mobile Payment' },
    ],
    },
    
    {
      name: 'transaction_reference',
      label: 'Transaction Reference',
      type: 'text',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Payment' : 'Create Payment'}</h1>
      <FormComponent
        fields={paymentFields}
        initialFormData={formData}
        route={route}
      />
    </div>
  );
};

export default PaymentInput;
